
        var result = require("!!../../node_modules/style-loader/index.js!../../node_modules/css-loader/index.js!./admin.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./app/admin/admin.component.css
// module id = 195
// module chunks = 0